export const ProjectsIcon: React.FC = () => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='19.614'
			height='19.613'
			className='projects-icon-svg'
			viewBox='0 0 19.614 19.613'>
			<g id='_006-rocket' data-name='006-rocket' transform='translate(0 0)'>
				<path
					id='Path_3409'
					data-name='Path 3409'
					d='M19.441,0A15.188,15.188,0,0,0,8.481,5.04,10.37,10.37,0,0,0,1.375,8.066a.409.409,0,0,0,.229.7l3.15.451-.389.436a.408.408,0,0,0,.016.561l5.252,5.252a.41.41,0,0,0,.561.016l.436-.389.451,3.15a.407.407,0,0,0,.289.315.376.376,0,0,0,.117.018.462.462,0,0,0,.316-.132,10.349,10.349,0,0,0,3-7.08A15.114,15.114,0,0,0,19.84.4a.411.411,0,0,0-.4-.4ZM15.675,7.057a2.043,2.043,0,1,1,0-2.89A2.037,2.037,0,0,1,15.675,7.057Z'
					transform='translate(-0.229 -0.001)'
					fill='#3b2a82'
				/>
				<path
					id='Path_3410'
					data-name='Path 3410'
					d='M2.226,16.74c-.874.874-2.075,4.825-2.209,5.272a.409.409,0,0,0,.391.526.419.419,0,0,0,.118-.017c.447-.134,4.4-1.335,5.272-2.209A2.526,2.526,0,0,0,2.226,16.74Z'
					transform='translate(0 -2.925)'
					fill='#3b2a82'
				/>
			</g>
		</svg>
	)
}
